import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {UserModelService} from '../../common/user-model.service';
import {WorkHistoryNotes} from './work-history-notes.model';

@Injectable()
export class WorkHistoryNotesService extends UserModelService<WorkHistoryNotes> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'workHistoryNotes', WorkHistoryNotes);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/work-history-notes/work-history-notes.service.ts